/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';

import {Logger} from '@/util/logger';

import 'ag-grid-community';
import 'ag-grid-enterprise';

import {first} from "rxjs/operators";

import {ServiceManager} from "@/services/service.manager";
import {RegressionViewerMetadata} from "@/screens/ide/regression.viewer.metadata";
import {RegressionParams} from "@/screens/ide/regressionviewer/regression.params";

import * as $ from 'jquery';
declare const Plotly

import {AgGridEvent, GetContextMenuItemsParams, Grid, GridApi, MenuItemDef} from 'ag-grid-community';

@Component({
  selector: 'regression-viewer',
  template: `
    <div
      id="regression-viewer-wrapper_{{uuid}}"
      class="regression-viewer-wrapper"
      style="display: block; float: left; padding: 8px; width: 100%; height: 100%;">

      <ul class="nav nav-pills" id="regression-viewer-nav-tab-{{uuid}}">

        <li class="nav-item active"><a class="nav-link active" id="regression-mrt-graph-tab-{{uuid}}" data-toggle="tab" href="#regression-mrt-graph-{{uuid}}" >MRT</a></li>
        <li class="nav-item active"><a class="nav-link "       id="regression-conflict-time-graph-tab-{{uuid}}" data-toggle="tab" href="#regression-conflict-time-graph-{{uuid}}" >Conflict Time (Hours)</a></li>
        <li class="nav-item active"><a class="nav-link "       id="regression-train-miles-graph-tab-{{uuid}}" data-toggle="tab" href="#regression-train-miles-graph-{{uuid}}" >Train Miles</a></li>

        <li class="nav-item active"><a class="nav-link "       id="regression-table-tab-{{uuid}}" data-toggle="tab" href="#regression-table-{{uuid}}">Table</a></li>

      </ul>

      <div class="tab-content clearfix regression-table" id="regression-table-{{uuid}}">
        <div class="tab-pane regression-table-pane" id="regression-table-pane-{{uuid}}">

          <div style="width: 100%; height: 64px;">
            <table cellpadding="0" cellspacing="0" style="text-align: left; height: 100%; width: 100%; padding-top: 8px;">
              <tr>
                <td style="text-align: right;">Name:</td>
                <td width="40%" style="padding-left: 8px;">{{name}}</td>
                <td style="text-align: right;">Start:</td>
                <td width="40%" style="padding-left: 8px;">{{start}}</td>
              </tr>
              <tr>
                <td style="text-align: right;">Corridor:</td>
                <td width="40%" style="padding-left: 8px;">{{corridor}}</td>
                <td style="text-align: right;">End:</td>
                <td width="40%" style="padding-left: 8px;">{{end}}</td>
              </tr>
            </table>
          </div>

          <ag-grid-angular
            id="ag-grid-regression-table_{{uuid}}"
            style="width: 100%; height: calc(100% - 64px);"
            class="ag-theme-balham-dark ag-grid-regression-table"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [context]="context"
            [animateRows]="true"
            [enableRangeSelection]="true"
            [rowSelection]="'multiple'"

            [components]="components"

            [allowContextMenuWithControlKey]="true"
            [getContextMenuItems]="getContextMenuItems"

            (gridReady)="onGridReady($event)"
          >
          </ag-grid-angular>

        </div>
      </div>

      <div class="tab-content clearfix regression-mrt-graph" id="regression-mrt-graph-{{uuid}}">
        <div class="tab-pane regression-mrt-graph-pane" id="regression-mrt-graph-pane-{{uuid}}">



        </div>
      </div>

      <div class="tab-content clearfix regression-conflict-time-graph" id="regression-conflict-time-graph-{{uuid}}">
        <div class="tab-pane regression-conflict-time-graph-pane" id="regression-conflict-time-graph-pane-{{uuid}}">



        </div>
      </div>

      <div class="tab-content clearfix regression-train-miles-graph" id="regression-train-miles-graph-{{uuid}}">
        <div class="tab-pane regression-train-miles-graph-pane" id="regression-train-miles-graph-pane-{{uuid}}">



        </div>
      </div>


    </div>

   `
})

/**
 *
 * @class RegressionViewer
 *
 * viewer for regression models
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2022
 *
 */
export class RegressionViewer implements AfterViewInit {

  /** common access to the various services */
  public services: ServiceManager       = null;

  public          errorText: string     = '<i class="wbedit-info-line"></i>';

  @Input()             uuid: number     = 0;

  /** bubble up a ready event when AGGrid is ready for use */
  @Output() ready                       = new EventEmitter<{status: boolean}>();

  /** the ag-grid widget */
  private              grid: Grid       = null;

  /** the API for the widget */
  private               api: GridApi    = null;

  private      isFullScreen: boolean    = false;

  private        currentTab: string     = 'MRT';

  public context  = {

    regressionviewer: this

  };

  public defaultColDef                  = {
    sortable:  false,
    filter:    true,
    resizable: true
  };

  public rowData: any                   = [];

  public components                     = {
  };

  public columnDefs: any[]              = [
  ];

  public blob: string                   = '';
  public name: string                   = '';
  public start: string                  = null;
  public end:   string                  = null;
  public corridor: string               = '';

  public conflictTime: RegressionParams = null;
  public mrt: RegressionParams          = null;
  public trainMiles: RegressionParams   = null;

  public series: Map<string, number[]>  = new Map<string, number[]>();

  /** @var _graph the Plotly graphing area */
  private        graph:      any = null;

  constructor(
    services: ServiceManager
  ) {

    this.services = services;
  }

  /** update the error line in the loader drop down */
  public status(msg: string =  '') {

    this.errorText = `<i class="wbedit-info-line">${msg}</i>`;
    Logger.info(`[rv] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public success(msg: string =  '') {

    this.errorText = `<i class="wbedit-success-line">${msg}</i>`;
    Logger.debug(`[rv] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public error(msg: string =  '') {

    this.errorText = `<i class="wbedit-error-line">${msg}</i>`;
    Logger.error(`[rv] ${msg}`);
  }


  /** when AGGrid is ready, tell everyone this window can be used! */
  onGridReady(params: AgGridEvent) {

    const rv: RegressionViewer = this;

    rv.grid      = null;
    rv.api       = params.api;

    Logger.debug('[rv] grid is ready...');

    /* start with the agGrid (table) tab shown */

    // @ts-ignore
    $(`#regression-mrt-graph-${this.uuid}`).tab('show');

    $(`#regression-viewer-nav-tab-${this.uuid} a`).on('click', function (e) {

      e.preventDefault();

      const tab = $(e.currentTarget).text();

      /* update which tab is visible */

      rv.currentTab = tab;

      /*
       * redraw teh graph for the tab we clicked on, because if it was a tab that wasn't
       * shown before...its width/height may have been zero...and now it's not, so we need
       * to recreate plotly to make sure it fills the cavity property.
       */

      if (rv.currentTab == 'MRT') {

        setTimeout( () => rv.renderMRT(), 50);

      } else if (rv.currentTab == 'Conflict Time (Hours)') {

        setTimeout( () => rv.renderConflictTime(), 50);

      } else if (rv.currentTab == 'Train Miles') {

        setTimeout( () => rv.renderTrainMiles(), 50);

      }

    });

    rv.ready.emit({status: true});
  }

  resize() {

    Logger.debug('[rv] resizing...');



  }

  renderTable() {

    const rv: RegressionViewer = this;

    rv.resize();

    Logger.debug('[rv] redrawing table...');

    /*
     * columns are the x-axis, the train counts at each tick.  the data is given to usu as
     * a simple ordered array, so just name the colum with the actual x-value, and use a
     * column id that is the order (and put them in that order)
     *
     */

    rv.columnDefs = [];
    rv.rowData    = [];

    rv.api.setGridOption("columnDefs", rv.columnDefs);
    rv.api.setGridOption("rowData",    rv.rowData);

    /* add the series columns */

    for (const v of rv.series.keys()) {

      rv.columnDefs.push({
                 colId: v,
            headerName: v,
                 field: v,
              editable: false,
                 width: 200,
        valueFormatter: (params) => {

          if (typeof params.value == 'string') {

            return params.value;
          }

          return params.value.toFixed(4)
        }

      });

    }

    /*
     * each data series is columnar data, so to build the rows we have to scan the
     * row of each series...
     *
     */

    const N: number = Array.from(rv.series.values())[0].length;

    for (let i=0; i<N; i++) {

      /* build a row ... */

      let rd: any   = {};

      rd.ordering   = i;
      rd.rowNum     = `_${i}`;

      for (const v of rv.series.keys()) {

        rd[v] = rv.series.get(v)[i];
      }

      /* save the row */

      rv.rowData.push(rd);
    }

    rv.rowData.sort((a, b) => {

      if (a.ordering > b.ordering) return 1;
      if (a.ordering < b.ordering) return -1;
      return 0;
    });

    /* render! */

    rv.api.setGridOption("columnDefs", rv.columnDefs);
    rv.api.setGridOption("rowData",    rv.rowData);

  }

  /* fetch the Y value along the regression line for this x value */
  interpolate(x: number, regression: RegressionParams): number {

    const rv: RegressionViewer = this;

    return x * regression.slope + regression.intercept;
  }

  renderConflictTime() {

    const rv: RegressionViewer = this;

    const id: string           = `regression-conflict-time-graph-pane-${rv.uuid}`;
    const xTitle: string       = `Sim Conflict Hours`;
    const yTitle: string       = `Historical Conflict Hours`;
    const xSeries: string      = `sim_conflict_time_h`;
    const ySeries: string      = `history_conflict_time_h`;
    const title: string        = `Conflict Time (Hours): ${this.name}`;
    const ySeriesName: string  = `Historical Conflict (H)`;

    this.renderGraph(id, title, ySeriesName, xTitle, yTitle, xSeries, ySeries, rv.conflictTime);
  }

  renderTrainMiles() {

    const rv: RegressionViewer = this;

    const id: string           = `regression-train-miles-graph-pane-${rv.uuid}`;
    const xTitle: string       = `Sim Train Miles`;
    const yTitle: string       = `Historical Train Miles`;
    const xSeries: string      = `sim_train_miles`;
    const ySeries: string      = `history_train_miles`;
    const title: string        = `Train Miles: ${this.name}`;
    const ySeriesName: string  = `Historical Train Miles`;

    this.renderGraph(id, title, ySeriesName, xTitle, yTitle, xSeries, ySeries, rv.trainMiles);
  }

  renderMRT() {

    const rv: RegressionViewer = this;

    const id: string           = `regression-mrt-graph-pane-${rv.uuid}`;
    const xTitle: string       = `Sim MRT`;
    const yTitle: string       = `Historical MRT`;
    const xSeries: string      = `sim_mrt_h`;
    const ySeries: string      = `history_mrt_h`;
    const title: string        = `MRT: ${this.name}`;
    const ySeriesName: string  = `Historical MRT`;

    this.renderGraph(id, title, ySeriesName, xTitle, yTitle, xSeries, ySeries, rv.mrt);

  }

  /** fetch the set of #ID for each pf the graph panes */
  graphPaneIDs() {

    const rv: RegressionViewer = this;

    return [
      `regression-conflict-time-graph-pane-${rv.uuid}`,
      `regression-train-miles-graph-pane-${rv.uuid}`,
      `regression-mrt-graph-pane-${rv.uuid}`
    ];
  }

  /** search the graph panes for one that is visible, and use it to get the pane height */
  paneHeight() {

    const rv: RegressionViewer = this;

    let height: number = 0;

    rv.graphPaneIDs().forEach((id: string) => {

      const hostElement: JQuery      =  $(`#${id}`);
      const         dom: HTMLElement = hostElement.get()[0];

      if (!dom || (height != 0)) {

        return ;
      }

      if (dom.clientHeight) {

        height = dom.clientHeight;
      }

    });

    return height;
  }

  /** search the graph panes for one that is visible, and use it to get the pane height */
  paneWidth() {

    const rv: RegressionViewer = this;

    let width: number = 0;

    rv.graphPaneIDs().forEach((id: string) => {

      const hostElement: JQuery      =  $(`#${id}`);
      const         dom: HTMLElement = hostElement.get()[0];

      if (!dom || (width != 0)) {

        return ;
      }

      if (dom.clientWidth) {

        width = dom.clientWidth;
      }

    });

    return width;
  }

  renderGraph(id: string, title, ySeriesName, xTitle: string, yTitle: string, xSeries: string, ySeries: string, regression: RegressionParams) {

    const rv: RegressionViewer = this;

    rv.resize();

    Logger.debug(`[rv] redrawing graph ${id}...`);

    const hostElement: JQuery      =  $(`#${id}`);
    const         dom: HTMLElement = hostElement.get()[0];
    const       width: number      = rv.paneWidth();
    const      height: number      = rv.paneHeight();

    $(hostElement).html();

    const layout = {
      autosize: true,
      paper_bgcolor: '#0d0d21',
      plot_bgcolor: '#0d0d21',
      dragmode: 'pan',
      hovermode: 'closest',
      title: title,
      font: {
        size: 12,
        color: '#f6f6f6'
      },
      yaxis: {
        color: '#f6f6f6',
        title: yTitle,
        spikemode: 'across',
        spikethickness: 1,
        spikedash: 'dash',
        spikecolor: '#e4e4e4',
        showgrid: true,
        gridwidth: 1,
        automargin: true
      },
      xaxis: {
        color: '#f6f6f6',
        title: xTitle,
        ticks: '',
        showticklabels: true,
        spikemode: 'across',
        spikethickness: 1,
        spikedash: 'dash',
        spikecolor: '#e4e4e4',
        showgrid: true,
        gridwidth: 1
      },
      showlegend: true,
      legend: {
        x: 1,
        y: 0.5
      }

    };

    /*
     * the regression line ...
     *
     * ref: https://github.com/plotly/plotly.js/issues/4921
     *
     */

    const fit_from = Math.min(...rv.series.get(xSeries));
    const fit_to   = Math.max(...rv.series.get(xSeries));

    const fit = {
      x: [fit_from, fit_to],
      y: [rv.interpolate(fit_from, regression), rv.interpolate(fit_to, regression)],
      mode: 'lines',
      type: 'scatter',
      name: `R=${regression.r_value.toFixed(4)}, P=${regression.p_value.toFixed(4)}`
    };

    const data: any = [];

    data.push(fit);

    /* the data series */

    data.push({
      x:    rv.series.get(xSeries),
      y:    rv.series.get(ySeries),
      text: rv.series.get('CALENDAR_DATE'),
      name: ySeriesName,
      mode: 'markers',
      type: 'scatter'
    });

    /* make the actual graph...*/

    Plotly.newPlot(dom, data, layout, {
       responsive: true,
       scrollZoom: true,
        watermark: false,
      displaylogo: false,
          logging: 1
    });
  }

  /** do column sizing after we actually have column data */
  onDataRendered(params: AgGridEvent) {

    this.api.autoSizeAllColumns();
  }

  public toggleFullScreen() {

    if (this.isFullScreen) {

      Logger.debug('[rv]', 'exiting full screen...');

      document.exitFullscreen();

    } else {

      Logger.debug('[rv', 'going full screen...');

      const elem = document.getElementById(`regression-viewer-wrapper_${this.uuid}`);

      if (elem.requestFullscreen) {

        elem.requestFullscreen();
      }
    }

  }

  /** build the right click menu for cells */
  public getContextMenuItems(params: GetContextMenuItemsParams): (string | MenuItemDef)[] {

    const rv: RegressionViewer = params.context.regressionviewer;

    /* give them the basic actions */

    return [
      'autoSizeAll',
      'copy',
      'copyWithHeaders',
      'resetColumns',
      'csvExport',
      'excelExport'
    ];
  }

  /** first time setup of view */
  ngAfterViewInit() {

    Logger.debug('[rv] view init...');

    this.clear();

    const elem = document.getElementById(`regression-viewer-wrapper_${this.uuid}`);

    const rv: RegressionViewer= this;

    elem.addEventListener('fullscreenchange', () => {

      rv.isFullScreen = document.fullscreenElement != null;

      Logger.debug('[rv]', '(elem) flipped full screen mode: ', rv.isFullScreen);

    }, true);

  }

  /** reset */
  public clear() {

    Logger.debug('[rv] resetting...');

    if (!this.api) {

      /* api isn't even available yet */

      return ;
    }

  }

  /** wrap it up! */
  public close() {

    Logger.debug('[rv] CLOSING...');



  }


  /** update the view to this regression */
  public refocus(meta: RegressionViewerMetadata) {

    const rv: RegressionViewer = this;

    Logger.debug(`[rv] refocusing`, meta);

    rv.blob     = meta.blob;
    rv.name     = meta.name;
    rv.start    = null;
    rv.end      = null;
    rv.corridor = '';

    /* fetch the JSON data */

    rv.services.blobber.contents(rv.blob, 'latest', 'json')
      .pipe(first())
      .subscribe(
        (content: any) => {

          /* set the meta data */

          Logger.debug(`[rv] setting metadata: `, content);

          rv.corridor   = content.user_params.corridor;
          rv.start      = content.user_params.end_date;
          rv.end        = content.user_params.start_date;

          /*
           * each of the data series is encoded as an object; the property names are
           * just the ordering index.
           *
           */

          /* read off the data series... */

          Object.entries(content.historic_data).forEach(([key, value]) => {

            const seriesName: string = key;

            let values: {idx: number, value: number}[] = [];

            Object.entries(value).forEach(([tag, datum]) => {

              const   idx: number = parseInt(tag);
              const value: number = datum as number;

              values.push({idx, value});
            });

            /* ensure its properly sorted */

            values.sort((a: {idx: number, value: number}, b: {idx: number, value: number}) => {

              return a.idx - b.idx;

            });

            /* remember this series */

            rv.series.set(seriesName, values.map(x => x.value));

          });

          if (rv.series.size == 0) {

            /* no data? */

            Logger.error(`[rv] no data series?`);

            return ;
          }

          /* the columns of the table are the series, and the rows are the series data (within each column) */

          /* all data series must have at least the same number of data points */

          const N: number = Array.from(rv.series.values())[0].length;

          for (let [k, v] of rv.series) {

             if (v.length < N) {

               Logger.error(`[rv] the '${k}' series does not have enough columns ${v.length} < ${N}.`);
             }

          }

          /* set the regression parameters */

          rv.conflictTime = new RegressionParams(content.regression_conflict_time);
          rv.mrt          = new RegressionParams(content.regression_mrt);
          rv.trainMiles   = new RegressionParams(content.regression_train_miles);

          /* update the table */

          rv.renderTable();

          /* render the graph */

          rv.renderMRT();

        },
        (error: any) => {

          Logger.error(`[rv] can't find content ${this.blob}: `, error);
        });



  }


  /* update the header area */
  public updateSummary() {

    Logger.debug(`[rv] updating summary...`);

  }

}
